import { CefSharpCardReader } from "Infrastructure/services/cefSharpService/local/CefSharpCardReader";
import { StartCardReaderUseCase } from "modules/cardReader/application/useCases/StartCardReaderUseCase";

const cefSharpCardReader = CefSharpCardReader();

export const enableSensor = async (cashlessCode?: string) => {
  return StartCardReaderUseCase(cefSharpCardReader, cashlessCode)
}